import elementsSatisfy from '../iterables/elementsSatisfy';

export default function isStringArray(value: unknown): value is string[] {
    return (
        Array.isArray(value) &&
        elementsSatisfy(value, (x) => typeof x === 'string')
    );
}
